import { Area } from '@core/area';

export class LandModalConfig {
  public key: string;
  public land: Area;
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/events/LandModalConfig.ts